import Dynamsoft from 'dwt'

import { getDWO } from './script'
import type { ImageID } from './types'

export const convertIndexToDPI = async (i: number, dpi: number): Promise<void> => {
    const dwo = await getDWO()

    return new Promise((resolve, reject) =>
        dwo.SetDPI(
            i,
            dpi,
            dpi,
            true,
            Dynamsoft.DWT.EnumDWT_InterpolationMethod.IM_BICUBIC,
            resolve,
            (errorCode, errorString) => reject(new Error(`convertIndexToDPI Error:${errorCode} ${errorString}`)),
        ),
    )
}

export const convertIndexToGrayScale = async (index: number): Promise<void> => {
    const dwo = await getDWO()

    return new Promise((resolve, reject) =>
        dwo.ConvertToGrayScale(index, resolve, (errorCode, errorString) =>
            reject(new Error(`convertIndexToGrayScale Error:${errorCode} ${errorString}`)),
        ),
    )
}

/** Blob defaults to octet-stream mime type as of dwt v17.2 */
export const convertIndexesToPDFBlob = async (indexes: number[]): Promise<Blob> => {
    const dwo = await getDWO()
    console.debug('convertIndexesToPDFBlob', indexes)
    dwo.JPEGQuality = 50
    console.debug('JPEGQuality', 50)
    return new Promise((resolve, reject) =>
        dwo.ConvertToBlob(indexes, Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF, resolve, (errorCode, errorString) =>
            reject(new Error(`convertIndexesToPDFBlob Error:${errorCode} ${errorString}`)),
        ),
    )
}

/** Blob defaults to octet-stream mime type as of dwt v17.2 */
export const convertToPDFBlob = async (imageIds: ImageID[]): Promise<Blob> => {
    const dwo = await getDWO()
    console.debug('convertToPDFBlob', imageIds)
    dwo.JPEGQuality = 50
    console.debug('convertToPDFBlob JPEGQuality', 50)
    dwo.Addon.PDF.SetResolution(200)
    console.debug('convertToPDFBlob PDFRes', 200)
    dwo.Addon.PDF.SetConvertMode(Dynamsoft.DWT.EnumDWT_ConvertMode.CM_AUTO)
    console.debug('convertToPDFBlob Rasterize')
    const indexes = imageIds.map((id) => dwo.ImageIDToIndex(id))
    console.debug('convertToPDFBlob indexes', indexes)
    if (indexes.includes(-1)) {
        throw new Error('Invalid Image Index')
    }
    return new Promise((resolve, reject) =>
        dwo.ConvertToBlob(indexes, Dynamsoft.DWT.EnumDWT_ImageType.IT_PDF, resolve, (errorCode, errorString) =>
            reject(new Error(`convertToPDFBlob Error:${errorCode} ${errorString}`)),
        ),
    )
}

export const convertFileToPdf = async (file: File | Blob): Promise<Blob> => {
    console.debug('convertFileToPdf')
    const dwo = await getDWO()
    console.debug('convertFileToPdf dwo', dwo)

    const nextIndex = dwo.HowManyImagesInBuffer

    await new Promise<void>((resolve, reject) =>
        dwo.LoadImageFromBinary(file, resolve, (errorCode, errorString) =>
            reject(new Error(`convertFileToPdf Error:${errorCode} ${errorString}`)),
        ),
    )

    return convertIndexesToPDFBlob([nextIndex])
}
